import { Fragment, useEffect, useState } from 'react';

import ObjectBrowser, { ObjectType, RadioFilter, RangeFilter } from '../../components/ObjectBrowser/ObjectBrowser';
import { useAppSelector } from '../../reducers/hooks';
import { Api } from '../../App';
import '../Steps.css';
import { MachineState } from '../../reducers/machineReducer';
import { MaterialState } from '../../reducers/materialReducer';


function ToolStep({step, dispatchStep, toolType, children}:any) {
    const [material, machine]: [MaterialState, MachineState] = useAppSelector((state) => [state.material, state.machine]);

    function awaitRangeFilter(objectsPromise: Promise<Array<any>>, filters: string, filter: 'min'|'max') {
        return new Promise<number>(async (resolve) => {
            let objects = await objectsPromise;

            if (filter === 'min') {
                if (objects.length === 0) {
                    resolve(0);
                    return;
                }
                resolve(objects.reduce((min: number, object: any) => object.attributes[filters] < min ? object.attributes[filters] : min, Infinity));
            } else {
                if (objects.length === 0) {
                    resolve(100);
                    return;
                }
                resolve(objects.reduce((max: number, object: any) => object.attributes[filters] > max ? object.attributes[filters] : max, 0));
            }
        })
    }

    function getFilters(machine: MachineState, toolType: 'endmills'|'drills') {
        let objectsPromise = toolType === 'endmills' ? Api.getEndmillsAsObjects(material, machine) : Api.getDrillsAsObjects(material, machine);

        let filters = [
            {
                name: 'Diameter',
                type: 'range',
                filters: 'diameter',
                min: awaitRangeFilter(objectsPromise, 'diameter', 'min'),
                max: awaitRangeFilter(objectsPromise, 'diameter', 'max')
            },
            {
                name: 'Cut Length',
                type: 'range',
                filters: 'cutLength',
                min: awaitRangeFilter(objectsPromise, 'cutLength', 'min'),
                max: awaitRangeFilter(objectsPromise, 'cutLength', 'max')
            },
            {
                name: 'Flutes',
                type: 'range',
                filters: 'flutes',
                min: awaitRangeFilter(objectsPromise, 'flutes', 'min'),
                max: awaitRangeFilter(objectsPromise, 'flutes', 'max'),
                step: 1
            },
            {
                name: 'Tool Units',
                type: 'radio',
                filters: 'InchMetric',
                options: [
                    { value: "INCH", name: 'Imperial (inch)' },
                    { value: "METRIC", name: 'Metric (mm)' }
                ]
            },
            "Filter the list below using these dropdowns."
        ]

        if (toolType === "endmills") {
            filters.unshift({
                name: 'Corner Radius',
                type: 'range',
                filters: 'cornerRadius',
                min: awaitRangeFilter(objectsPromise, 'cornerRadius', 'min'),
                max: awaitRangeFilter(objectsPromise, 'cornerRadius', 'max'),
            })
        }
        return filters;
    }

    const [filters, setFilters] = useState<Array<any>>(getFilters(machine, toolType));    
    useEffect(() => setFilters(getFilters(machine, toolType)), [machine, toolType]);

    return (
        <Fragment>
            {toolType === 'endmills' && <ObjectBrowser
                type={ObjectType.ENDMILL}
                style={{display: step >= 3 ? 'flex' : 'none'}}
                searchPlaceholder="endmills by EDP, Series..."
                objects={Api.getEndmillsAsObjects(material, machine)}
                changeStep={dispatchStep}
                footer={
                    <footer className="objectBrowserFooter">
                        <b>Can't find the tool you're looking for?</b>
                        <span>We've selected the tools most applicable to your material. Try a different material to see other tools.</span>
                    </footer>
                }
                filters={filters}
            >{children}</ObjectBrowser>}
            {toolType === 'drills' && <ObjectBrowser
                type={ObjectType.DRILL}
                style={{display: step >= 3 ? 'flex' : 'none'}}
                searchPlaceholder="drills by EDP, Series..."
                objects={Api.getDrillsAsObjects(material, machine)}
                footer={
                    <footer className="objectBrowserFooter">
                        <b>Can't find the tool you're looking for?</b>
                        <span>We've selected the tools most applicable to your material. Try a different material to see other tools.</span>
                    </footer>
                }
                changeStep={dispatchStep}
                filters={filters}
            >{children}</ObjectBrowser>}
        </Fragment>
    )
}

export default ToolStep;